module.exports = __webpack_public_path__ + "img/print.644b7e84.png";